import {Component, OnInit, ElementRef } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  password: string;
  repeatPassword:string;
  email: string;
  message: string;
  fail: boolean;
  isValid = false;
  passwordsMatch: boolean = false;
  showPassword: boolean = false;
  showMatchPassword: boolean = false;
  invalidPassword: boolean;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public auth: AuthService,
    private el: ElementRef
  ) {}

  ngOnInit() {
    document.body.style.background = '#f0f2f5';
    this.message = '';
    this.password = '';
    // Check if token sent in url is valid
    this.auth.checkRecoveryToken(this.route.snapshot.paramMap.get('token')).subscribe( (result) => {
      this.email = result.email;
      this.isValid = true;
    }, (error) => {
      this.isValid = false;
      this.message = 'Este enlace no es válido o ya expiró';
    });
  }

  reload () {
    location.reload();
  }

  onSubmit() {
    if(this.repeatPassword == this.password){
      this.auth.resetPassword(this.email, this.password, this.route.snapshot.paramMap.get('token')).subscribe(
        (result: any) => {
          this.message = result.message;
          this.fail = false;
        },
        (error) => {
          this.message = error.error.message;
          this.fail = true;
          console.error(error);
        });
    }
  }

  confirmPassword(){
    if(this.repeatPassword!=this.password){
      this.passwordsMatch = true;
    }else{
      this.passwordsMatch = false;
    }
  }

  public changeVisibility(){
    if (!this.showPassword) {
      this.el.nativeElement.querySelector('#passwordInput').setAttribute('type', 'text');
      this.el.nativeElement.querySelector('#visibilityIcon').setAttribute('class', 'fa fa-eye');
      this.showPassword = true;
    } else {
      this.el.nativeElement.querySelector('#passwordInput').setAttribute('type', 'password');
      this.el.nativeElement.querySelector('#visibilityIcon').setAttribute('class', 'fa fa-eye-slash');
      this.showPassword = false;
    }
  }

  public validatePassword() {
    let hasLower = false;
    let hasUpper = false;
    let hasNum = false;
    let hasAtLeast = false;

    const lowercaseRegex = new RegExp("(?=.*[a-z])");// has at least one lower case letter
    if (lowercaseRegex.test(this.password)) {
      hasLower = true;
    }

    const uppercaseRegex = new RegExp("(?=.*[A-Z])"); //has at least one upper case letter
    if (uppercaseRegex.test(this.password)) {
      hasUpper = true;
    }

    const numRegex = new RegExp("(?=.*\\d)"); // has at least one number
    if (numRegex.test(this.password)) {
      hasNum = true;
    }
    if (this.password.length >=8) {
      hasAtLeast = true;
    }

    this.invalidPassword = this.passwordFails([hasLower, hasUpper, hasNum, hasAtLeast]);
  }

  passwordFails(checks: boolean[]): boolean {
     let counter = 0;
    for (let i = 0; i < checks.length; i++) {
      if (checks[i]) {
        counter += 1;
      }
    }
    return counter < 4;
 }

 public changeVisibilityConfirm(){
   if (!this.showMatchPassword) {
     this.el.nativeElement.querySelector('#verifyPassword').setAttribute('type', 'text');
     this.el.nativeElement.querySelector('#visibilityConfirmIcon').setAttribute('class', 'fa fa-eye');
     this.showMatchPassword = true;
   } else {
     this.el.nativeElement.querySelector('#verifyPassword').setAttribute('type', 'password');
     this.el.nativeElement.querySelector('#visibilityConfirmIcon').setAttribute('class', 'fa fa-eye-slash');
     this.showMatchPassword = false;
   }
 }

}
